import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

interface GridRecordsProps {
  onFetch: (
    setItems: (data: any[], nextOffset: number) => void,
    nextOffset: number
  ) => Promise<void>;
  refresher: { token: any };
  renderItem?: (item: any, index: number) => JSX.Element;
}

export function useRefresher(): { token: number; refresh: () => void } {
  const [token, setToken] = useState(0);
  return {
    token,
    refresh: () => {
      setToken(new Date().getTime());
    },
  };
}

const SpinnerGridPanel = () => (
  <div className="flex items-center justify-center space-x-2 py-10">
    <i className="fa-solid fa-spinner fa-spin text-2xl text-neutral-600"></i>
    <span className="text-lg text-neutral-600">Loading...</span>
  </div>
);

const ItemCard: React.FC = () => {
  return (
    <div className="rounded-lg border bg-white shadow-sm cursor-pointer hover:shadow-md transition-shadow">
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold">Titulo</h3>
        </div>
        <p className="text-neutral-600 mb-4">Descrição do Item</p>
      </div>
    </div>
  );
};

export const GridRecords: React.FC<GridRecordsProps> = (props) => {
  const {
    onFetch,
    refresher,
    renderItem = (item, index) => <ItemCard key={index} />,
  } = props;

  const [items, setItems] = useState<any[]>([]);
  const [hasNext, setHasNext] = useState(true);
  const [nextOffset, setNextOffset] = useState(0);
  const [internalToken, setInternalToken] = useState(0);

  const internalSetItems = (data: any[], nextOffset: number) => {
    const newItems = [...items, ...data];
    setItems(newItems);

    const aux = data && data.length ? nextOffset : -1;

    setNextOffset(aux);
    setHasNext(aux !== -1);
  };

  const fetch = () => {
    (async () => {
      if (onFetch && hasNext) {
        await onFetch(internalSetItems, nextOffset);
      }
    })();
  };

  useEffect(() => {
    setItems([]);
    setHasNext(true);
    setNextOffset(0);

    setInternalToken(refresher?.token);
  }, [refresher?.token]);

  useEffect(() => {
    fetch();
  }, [internalToken]);

  return (
    <InfiniteScroll
      className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
      dataLength={items.length}
      next={fetch}
      hasMore={hasNext}
      loader={
        <div className="col-span-1 md:col-span-2 lg:col-span-3">
          <SpinnerGridPanel />
        </div>
      }
    >
      {items && items.map(renderItem)}
    </InfiniteScroll>
  );
};
